import { createFileRoute } from '@tanstack/react-router';
import { LoyaltyListPage } from './LoyaltyListPage';

export const Route = createFileRoute('/_protected/admin/loyalty/')({
  component: LoyaltyListPage,
});
